"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledSidebarWideButtonText = void 0;
var style_utils_1 = require("@nef/style-utils");
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var Box_1 = __importDefault(require("../../Box"));
var Text_1 = __importDefault(require("../../Text"));
var Sidebar_1 = require("../../Sidebar");
var innerFunction = function (_a) {
    var active = _a.active, props = __rest(_a, ["active"]);
    return react_1.default.createElement(Text_1.default, __assign({}, props));
};
exports.StyledSidebarWideButtonText = styled_components_1.default(innerFunction)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  display: block;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 16px;\n  max-width: 12.42857rem;\n\n  ", ";\n"], ["\n  color: ", ";\n  display: block;\n  font-size: 1rem;\n  font-weight: 500;\n  line-height: 16px;\n  max-width: 12.42857rem;\n\n  ",
    ";\n"])), style_utils_1.getSidebarColor(800), function (props) {
    return props.$rtl && styled_components_1.css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      text-align: right;\n    "], ["\n      text-align: right;\n    "])));
});
var SidebarWideButtonText = function (props) {
    var rtl = react_1.default.useContext(Sidebar_1.SidebarContext).rtl;
    return (react_1.default.createElement(Box_1.default, { marginLeft: !rtl ? 3 : "none", marginRight: rtl ? 3 : "none" },
        react_1.default.createElement(exports.StyledSidebarWideButtonText, __assign({ "$rtl": rtl }, props))));
};
exports.default = SidebarWideButtonText;
var templateObject_1, templateObject_2;
//# sourceMappingURL=index.js.map